import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { useAuthStore } from '../../contexts/AuthContext';

export default function WelcomeBanner() {
    const { user } = useAuthStore();

    return (
        <Grid item  sx = {{ width: "100%", height: "26px"}}>
            <Typography variant="h1" color="common.white">Welcome{user.firstName&&`, ${user.firstName}`}!</Typography>
        </Grid>
    )
}